export enum CreateOrganizationResultType {
    DnsNameUnavailable = 'This Organization URL Name is not available (anymore).',
    InvalidName = 'This Organization Name is not allowed.',
    InvalidDnsName = 'This Organization URL Name is not allowed.',
    Unknown = 'An unknown error has occurred while creating the Organization.',
}
